import type { FaireProductEntity } from "../../entity_types/product";

export const p_5zmfxdeu74: FaireProductEntity = {
  token: "p_5zmfxdeu74",
  type: "product",
  name: "SUMMER TRUFFLE GROUND 180 g",
  brandToken: "b_bsvsnrtuas",
  brandName: "La Spora Tartufi",
  imageUrl:
    "https://cdn.faire.com/fastly/024f908528990f97c35d139b5e9ebcd86c0c9fd9f2a5398ca69d699e4eb56854.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0dc31dc893af00dd9c5abe8f8e1865ebe203aa6530b2cf3bf52f37953a9937f.webp",
    "https://cdn.faire.com/fastly/d6dbfa19a60701b954c6f4e704396ed50819fcff77896118af966b38d2b227ac.jpeg",
    "https://cdn.faire.com/fastly/d9b4fe26c96d28bb6a141bb7d515b3e7f60895ed8f2b3cc5e83bef35c7fff05e.jpeg",
    "https://cdn.faire.com/fastly/ae978454b00c77a289eeba868d5bfa779bf892356c7f4886a18bdec2d95dfc77.jpeg",
  ],
  priceDollars: 26.2,
  description:
    "Summer truffle (Tuber Aestivum Vitt.) origin Italy 65%, olive oil, salt, natural flavors.\n\nA tasty and versatile product suitable for a wide variety of culinary uses. It is ideal as a seasoning for crostini and fillings for appetizers, first and second courses, omelets, and as a base for all truffle dishes. It can be used in the filling of ravioli, cannelloni, gnocchi, to stuff lasagna, or as a seasoning for fish or meat dishes.\n\nSize: 180 g",
  tags: [],
  msrpDollars: 52.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:18.893Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
